export default "__VITE_ASSET__DSpe6OF3__"